/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 29/04/2025 17:36
 *
 */

import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormComponent,
  SearchFilterComponent,
} from '@infodata-group/inf-commons-desktop';
import { TranslateModule } from '@ngx-translate/core';
import {
  ActionEvent,
  PropertyType,
  StandardAction,
} from '@infodata-group/inf-commons';
import { StandardSearchManager } from '../../manager/standard-search-manager';
import { ToolsActions } from '../../engine/tools/tools-actions';

@Component({
  selector: 'infl-standard-search-filter',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    SearchFilterComponent,
    FormComponent,
  ],
  templateUrl: './standard-search-filter.component.html',
  styleUrl: './standard-search-filter.component.scss',
})
export class StandardSearchFilterComponent implements OnChanges, AfterViewInit {
  readonly REFRESH_ACTION = ToolsActions.getRefreshAction();
  readonly DELETE_TAG_ACTION = new StandardAction(
    'delete-tag',
    '',
    'i18n.common.actions.delete',
    'i18n.common.actions.delete',
  );

  @Input() manager: StandardSearchManager;
  @Input() autoOpen = false;
  @Input() displayTitle = true;
  @Input() styleForContent = '';
  @Input() noPaddingForm = true;

  @Output() action = new EventEmitter<ActionEvent>();
  @Output() fieldChange = new EventEmitter<SimpleChanges>();

  @ViewChild('searchFilterComponent')
  searchFilterComponent: SearchFilterComponent;
  @ViewChild('form') form: FormComponent;

  ngOnChanges(changes: SimpleChanges) {
    if (Object.hasOwn(changes, 'manager') && this.manager) {
      setTimeout(() => {
        this.manager.form = this.form;
      }, 200);
    }
  }

  ngAfterViewInit(): void {
    if (this.autoOpen) {
      this.searchFilterComponent.slideMenu.open();
    }
  }

  public listenSearchFilterRefresh(): void {
    const data = this.form.validate();
    if (!data) {
      return;
    }
    this.searchFilterComponent.slideMenu.close();
    this.action.emit(new ActionEvent('click', this.REFRESH_ACTION, null));
  }

  public listenSearchFilterDeleteTag($event: string): void {
    delete this.manager.entity[$event];
    this.action.emit(new ActionEvent('click', this.DELETE_TAG_ACTION, $event));
  }

  public listenFormFieldChange($event: SimpleChanges): void {
    Object.keys($event).forEach((key) => {
      this.manager.entity[key] = $event[key].currentValue;
      const prop = this.manager.model.find(key);
      try {
        if (
          prop.type === PropertyType.interval &&
          !this.manager.entity[key].start &&
          !this.manager.entity[key].end
        ) {
          delete this.manager.entity[key];
        }
      } catch (e) {
        // CustomLogger.e(e);
      }
    });
    this.manager.saveSearch();
    this.fieldChange.emit($event);
  }

  public open(): void {
    this.searchFilterComponent.slideMenu.open();
  }

  public close(): void {
    this.searchFilterComponent.slideMenu.close();
  }
}
